let home = {
    init: function () {
        home.contentSkip();
    },

    contentSkip: function () {
        $(document).on('click', '.home .skip-navigation', function (e) {
            e.preventDefault();
            $('html, body').animate(
                {
                    scrollTop: $('.why-us').offset().top - 100,
                },
                1000
            );
        });
    },
};

$(document).ready(function () {
    home.init();
});
